export {
 INTEREST_OPTIONS,
 getValueBandsForInterest
} from './interestValueCatalog';

/**
 * Submit the contact form to the Vercel serverless API (Resend + Turnstile).
 */
export async function submitContact(fields, { signal } = {}) {
 const response = await fetch('/api/contact', {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 signal,
 body: JSON.stringify({
 name: fields.name,
 email: fields.email,
 organization: fields.organization,
 phone: fields.phone || '',
 smsConsent: fields.smsConsent === true,
 // Must match api/contact.js SMS_CONSENT_ATTESTATION for consent to be accepted.
 smsConsentAttestation: fields.smsConsent === true ? 'WEB_FORM_CHECKBOX_V1' : '',
 interest: fields.interest,
 valueBandId: fields.valueBandId || '',
 message: fields.message,
 company_url: fields.company_url || '',
 turnstileToken: fields.turnstileToken || '',
 formOpenedAt: fields.formOpenedAt,
 formSubmissionId: fields.formSubmissionId || '',
 formName: fields.formName || 'Contact Us',
 pageUrl: fields.pageUrl || '',
 landingPage: fields.landingPage || '',
 referrer: fields.referrer || '',
 utmSource: fields.utmSource || '',
 utmMedium: fields.utmMedium || '',
 utmCampaign: fields.utmCampaign || '',
 utmTerm: fields.utmTerm || '',
 utmContent: fields.utmContent || ''
 })
 });

 let data = null;
 try {
 data = await response.json();
 } catch (e) {
 data = null;
 }

 if (!response.ok || !data || !data.ok) {
 let error =
 (data && data.error) ||
 (response.status === 429
 ? 'Too many requests. Please try again later.'
 : 'Unable to send your message right now. Please try again.');

 // CRA's own port has no /api - vercel dev proxies it on :3000.
 if (
 response.status === 404 ||
 (typeof data === 'string' && data.includes('Cannot POST'))
 ) {
 error =
 'Contact API is not available on this URL. Open http://localhost:3000 (vercel dev), not the CRA port.';
 }

 const err = new Error(error);
 err.status = response.status;
 throw err;
 }

 return data;
}
